// usePanelHistory.ts
import { type IRightSection } from '@components/utils/right-panel/utils';
import { useState } from 'react';

export interface IUsePanelHistory {
	current: IRightSection<{}>;
	goTo: (action: IRightSection<{}>) => void;
	goBack: () => void;
	goForward: () => void;
	canGoBack: boolean;
	canGoForward: boolean;
	reset: () => void;
}

export const usePanelHistory = (rightPanel: IRightSection<{}>): IUsePanelHistory => {
	const [stack, setStack] = useState<IRightSection<{}>[]>(rightPanel ? [rightPanel] : []);
	const [index, setIndex] = useState(0);

	const current = stack[index] || null;

	const goTo = (action: IRightSection<{}>) => {
		const newStack = stack.slice(0, index + 1);
		newStack.push(action);
		setStack(newStack);
		setIndex(newStack.length - 1);
	};

	const goBack = () => {
		if (index > 0) setIndex((i) => i - 1);
	};

	const goForward = () => {
		if (index < stack.length - 1) setIndex((i) => i + 1);
	};

	const reset = () => {
		setStack(rightPanel ? [rightPanel] : []);
		setIndex(0);
	};

	return {
		current,
		goTo,
		goBack,
		goForward,
		canGoBack: index > 1,
		canGoForward: index < stack.length - 1,
		reset,
	};
};
